import React, { Component } from "react";
import { Grid, Row, Col, Table, Modal } from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import { WEB_URL, thArray, tdArray } from "variables/Variables.jsx";
import ProgressButton from "components/ProgressButton/ProgressButton.jsx";
import InjectedCheckoutForm from 'components/CheckoutForms/CheckoutForm.jsx';
import {Elements} from 'react-stripe-elements';
import Button from "components/CustomButton/CustomButton.jsx";
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem, Divider } from 'rc-menu';
import 'rc-dropdown/assets/index.css';

function onVisibleChange(visible) {
  console.log(visible);
}

function menuRow(ctx,prop){
  return <Menu>
            <MenuItem key="1">
              <ProgressButton runningAsyncOperation={false} bsStyle="default pull-right btn-xs" style={{marginRight:0,'min-height':'28px','min-width':'140px'}} fill type="submit" onClick={(e) => ctx.viewFormsData(prop, e)}>
                <i style={{float:'left',padding:3,fontWeight:'bold'}} class="pe-7s-note2"></i><span style={{float:'left',paddingLeft:14}}>Forms</span>
              </ProgressButton>
            </MenuItem>
            <MenuItem key="2">
              <ProgressButton runningAsyncOperation={false} bsStyle="default pull-right btn-xs" style={{marginRight:0,'min-height':'28px','min-width':'140px',marginTop:10}} fill type="submit" onClick={(e) => ctx.viewLeads(prop, e)}>
                <i style={{float:'left',padding:3,fontWeight:'bold'}} class="pe-7s-share"></i><span style={{float:'left',paddingLeft:14}}>Leads</span>
              </ProgressButton>
            </MenuItem>
            <MenuItem key="2">
              <ProgressButton runningAsyncOperation={false} bsStyle="default pull-right btn-xs" style={{marginRight:0,'min-height':'28px','min-width':'140px',marginTop:10}} fill type="submit" onClick={(e) => ctx.viewTrackableLinks(prop, e)}>
                <i style={{float:'left',padding:3}} class="fa fa-external-link"></i><span style={{float:'left',paddingLeft:14}}>Trackable Links</span>
              </ProgressButton>
            </MenuItem>
            <MenuItem key="3">  
            <ProgressButton style={{'min-height':'28px','min-width':'140px',marginTop:10}} bsStyle="danger pull-right btn-xs" fill type="submit" onClick={(e) => {ctx.deletePublication(prop,e);}}>
              <i style={{float:'left',padding:3}} class="fa fa-remove"></i><span style={{float:'left',paddingLeft:14}}>Delete</span>
              </ProgressButton>
            </MenuItem>
          </Menu>
}
function PurchaseMoreStorage(props) {
  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Purchase More Cloud Storage (${props.totalToPurchase}, annual fee)
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div className="content paymentForm">
          <Elements>
            <InjectedCheckoutForm createSubscription={true} product='addstorage' transactionAmount={props.totalToPurchase} authEmail={props.authEmail} setLoggedIn={props.setLoggedIn} onHide={props.onHide} authDetail={props.authDetail} triggerNotification={props.triggerNotification} />
          </Elements>
        </div>
      </Modal.Body>
      <Modal.Footer>
      <p style={{fontSize:14,paddingLeft:15,paddingRight:15}}>Your credit card transaction is securely processed by <a href="https://stripe.com/" rel="nofollow" target="_new">Stripe</a>.</p>
        <Button bsStyle="default pull-right" fill type="submit"  onClick={props.onHide}>
                Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

class TableList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cloudpublications : null,
      cloudHeaders : ["Name", "Action"],
      runningDeleteCloudPublication : false,
      showPurchaseMoreStorage : false,
      runningCancelExtraStorage : false,
      totalToPurchase : 50
    }
  }

  componentDidMount () {
    this.fetchCloudPublications()
  }

  fetchCloudPublications(){
    fetch("https://"+WEB_URL+"/account/api/getcloudpublications",{
      'method' : 'POST',
      'headers' : { 'Content-Type' : 'application/json'},
      //'body' : 'token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum
      'body' : JSON.stringify({'token':this.props.authDetail.token,'checksum':this.props.authDetail.checksum})
    }).then(res => res.json())
      .then(
        (response) => {
          if(response.result == 'SUCCESS'){
            var cp = [];
            for(var p=0;p<response.list.length;p++){
              cp.push([response.list[p]]);
            }
            this.setState({cloudpublications : cp})
            this.setState({runningDeleteCloudPublication : false});
          }
        },
        (error) => {
          this.setState({runningDeleteCloudPublication : false});
        }
      )
  }

  componentWillReceiveProps (nextProps) {
    
  }

  componentWillUpdate (nextProps, nextState) {
    
  }

  getCloudLink(publication){
    if(this.props.authDetail.detail.cloudId && this.props.authDetail.detail.cloudId != this.props.authDetail.user){
      return "https://"+this.props.authDetail.detail.cloudId+".flowpaper.com/"+publication+"/";
    }else{
      return "https://online.flowpaper.com/"+this.props.authDetail.user+"/"+publication+"/";
    }
  }

  openPublication(publication,e){
    var pubUrl = this.getCloudLink(publication);
    window.open(pubUrl);

    e.preventDefault();
  }

  viewLeads(publication,e){
    this.props.history.push('/home/leads/'+publication);
  }

  viewHeatMap(publication,e){
    this.props.history.push('/home/heatmap/'+publication+'/0');
  }
  
  viewAnalytics(publication,e){
    this.props.history.push('/home/analytics/'+publication+'/0');
  }

  viewFormsData(publication,e){
    this.props.history.push('/home/forms/'+publication);
  }

  viewTrackableLinks(publication,e){
    this.props.history.push('/home/trackablelinks/'+publication);
  }

  deletePublication(publication,e){
    if(window.confirm('Are you sure you want to delete this publication ("'+publication[0]+'")?')){
      this.setState({runningDeleteCloudPublication : publication[0]});

      fetch("https://"+WEB_URL+"/account/api/deletecloudpublication",{
        'method' : 'POST',
        'headers' : { 'Content-Type' : 'application/json'},
        //'body' : 'token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&identifier='+publication[0]
        'body' : JSON.stringify({'token':this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'identifier':publication[0]})
      }).then(res => res.json())
        .then(
          (response) => {
            if(response.result == 'SUCCESS'){
              this.props.triggerNotification('success','tc',response.message);
              this.fetchCloudPublications();
            }else{
              this.props.triggerNotification('error','tc',response.message);  
              this.setState({runningDeleteCloudPublication : false});
            }
          },
          (error) => {
            this.props.triggerNotification('error','tc','Error deleting publication. Please try again in a little while.');
            this.setState({runningDeleteCloudPublication : false});
          }
        )
    }else{
      this.setState({runningDeleteCloudPublication : false});
    }
    
    e.preventDefault();
  }

  cancelExtraStorage(e){
    var _this = this;

    if(window.confirm('Are you sure you want to cancel your extra storage?')){
      this.setState({runningCancelExtraStorage : true});

        fetch("https://"+WEB_URL+"/account/api/creative-services",{
          'method' : 'POST',
          'headers' : { 'Content-Type' : 'application/json'},
          //'body' : 'action=cancelsubscription&product=storage&token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&email='+this.props.authDetail.detail.email
          'body' : JSON.stringify({'action':'cancelsubscription','product':'storage','token':this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'email':this.props.authDetail.detail.email})
        }).then(res => res.json())
        .then(
          (response) => {
            if(response.result == 'SUCCESS'){
              this.setState({runningCancelExtraStorage : false});

              // triggering log in again so we get a new cookie
              fetch("https://"+WEB_URL+"/account/api/login",{
                'method' : 'POST',
                'headers' : { 'Content-Type' : 'application/json'},
                'body' : JSON.stringify({'token':this.props.authDetail.token,'email':this.props.authDetail.checksum,'detail':true}),
                'credentials': 'same-origin'
              }).then(res => res.json())
              .then(
                  (result) => {
                      if(result.auth == 'AUTH_OK'){
                          _this.props.setLoggedIn(result,_this.props.authEmail,true);
                      }else{
                          _this.props.setLoggedIn(false);    
                      }
                  },
                  (error) => {
                      _this.props.setLoggedIn(false);
                  }
              )   
            }else{
                this.props.triggerNotification('error','tc','Subscription system currently unavailable. Please contact support for assistance.');    
            }

            this.props.triggerNotification('success','tc','Your extra storage has been cancelled.');
          },
          (error) => {
            this.props.triggerNotification('error','tc','Subscription system currently unavailable. Please contact support for assistance.');
            this.setState({runningCancelExtraStorage : false});
          }
        )
    }
  }

  showPurchaseStorage(e,numExtraPublications){
    var _this = this;

    if((isFromEU() || (_this.props.authDetail.detail.BillingCountry && euCountries.includes(_this.props.authDetail.detail.BillingCountry))) && !_this.props.authDetail.detail.TaxID){
      this.props.triggerNotification('error','tc','Please update your VAT/Tax ID before purchasing additional storage.');    
    }else{
      this.setState({showPurchaseMoreStorage : true, totalToPurchase : numExtraPublications});
    }
  }

  hidePurchaseMoreStorage(e){
    this.setState({showPurchaseMoreStorage : false});
  }

  render() {
    return (
      <div className="content">
        {this.state.cloudpublications!=null ? 
        <Grid fluid>
          <Row>
            <Col md={11}>
            {this.state.cloudpublications.length ? 
            <Card
                title=""
                category={"Quota Used "+this.state.cloudpublications.length+"/"+this.props.authDetail.detail.cloudAllowance+" publications"}
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    {
                    this.props.authDetail.detail.show_expand_storage?
                    <div>
                      <ProgressButton runningAsyncOperation={this.state.showPurchaseMoreStorage} bsStyle="info pull-right" fill type="submit" style={{marginRight:15}} onClick={(e) => {this.showPurchaseStorage(e,500);}}>
                          Purchase Additional Storage<span style={{'display':'block','font-size':'11px','border-top':'1px solid #ffffff'}}>500 additional publications</span>
                      </ProgressButton>
                      <ProgressButton runningAsyncOperation={this.state.showPurchaseMoreStorage} bsStyle="info pull-right" fill type="submit" style={{marginRight:15}} onClick={(e) => {this.showPurchaseStorage(e,50);}}>
                          Purchase Additional Storage<span style={{'display':'block','font-size':'11px','border-top':'1px solid #ffffff'}}>50 additional publications</span>
                      </ProgressButton>
                      <PurchaseMoreStorage authEmail={this.props.authEmail} setLoggedIn={this.props.setLoggedIn} triggerNotification={this.props.triggerNotification} authDetail={this.props.authDetail} show={this.state.showPurchaseMoreStorage} totalToPurchase={this.state.totalToPurchase} onHide={() => this.hidePurchaseMoreStorage(false)} />
                    </div>
                  :''}
                  {this.props.authDetail.detail.show_cancel_storage?
                    <ProgressButton runningAsyncOperation={this.state.runningCancelExtraStorage} bsStyle="warning pull-right" fill type="submit" onClick={(e) => {this.cancelExtraStorage(e);}}>
                          Cancel My Extra Storage
                      </ProgressButton>
                  :''}
                  <Table striped hover>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th className="pull-right">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.cloudpublications.map((prop, key) => {
                        return (
                          <tr key={key}>
                            {prop.map((prop, key) => {
                              return <td key={key} style={{'max-width':0}}><a style={{'overflow':'hidden','display':'block','text-overflow': 'ellipsis'}} href={this.getCloudLink(prop)} target="_new">{prop}</a></td>;
                            })}
                            {/* <td style={{'width':'30px','padding':0,'padding-right':'5px'}}>
                            <ProgressButton runningAsyncOperation={this.state.runningDeleteCloudPublication == prop} style={{'min-height':'28px','min-width':'78px'}} bsStyle="danger pull-right btn-xs" fill type="submit" onClick={(e) => {this.deletePublication(prop,e);}}>
                            Delete
                            </ProgressButton>
                            </td> */}
                            <td style={{'width':'30px','padding':0,'padding-right':'5px'}}>
                            <ProgressButton runningAsyncOperation={false} bsStyle="info pull-right btn-xs" style={{marginRight:0,'min-height':'41px','min-width':'85px'}} fill type="submit" onClick={(e) => this.openPublication(prop, e)}>
                            <i class="fa fa-external-link"></i> View
                            </ProgressButton> 
                            </td>
                            <td style={{'width':'30px','padding':0,'padding-right':'5px'}}>
                            <ProgressButton runningAsyncOperation={false} bsStyle="default pull-right btn-xs" style={{marginRight:0,'min-height':'41px','min-width':'85px'}} fill type="submit" onClick={(e) => this.viewHeatMap(prop, e)}>
                            <i class="pe-7s-look"></i> Heatmap
                            </ProgressButton>
                            </td>
                            <td style={{'width':'30px','padding':0,'padding-right':'5px'}}>
                            <ProgressButton runningAsyncOperation={false} bsStyle="default pull-right btn-xs" style={{marginRight:0,'min-height':'41px','min-width':'85px'}} fill type="submit" onClick={(e) => this.viewAnalytics(prop, e)}>
                            <i class="pe-7s-graph1"></i> Stats
                            </ProgressButton>
                            </td>
                            <td style={{'width':'30px','padding':0,'padding-right':'5px'}}>
                              <Dropdown
                                trigger={['click']}
                                overlay={menuRow(this,prop)}
                                animation="slide-up"
                                onVisibleChange={onVisibleChange}
                              >
                                <button style={{ 'width': 85,'font-size':'12px' }}><i class="pe-7s-more"></i><br/>More</button>
                              </Dropdown>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  </div>
                }
              />:<Card
              title=""
              category={"Quota Used 0/"+this.props.authDetail.detail.cloudAllowance+" publications"}
              ctTableFullWidth
              ctTableResponsive
              content={
                <div style={{margin:20}}>
                  <p style={{marginBottom:20}}>{
                    this.props.authDetail.detail.show_expand_storage?
                    <div>
                      <ProgressButton runningAsyncOperation={this.state.showPurchaseMoreStorage} bsStyle="info pull-right" fill type="submit" style={{marginRight:15}} onClick={(e) => {this.showPurchaseStorage(e,500);}}>
                          Purchase Additional Storage<span style={{'display':'block','font-size':'11px','border-top':'1px solid #ffffff'}}>500 additional publications</span>
                      </ProgressButton>
                      <ProgressButton runningAsyncOperation={this.state.showPurchaseMoreStorage} bsStyle="info pull-right" fill type="submit" style={{marginRight:15}} onClick={(e) => {this.showPurchaseStorage(e,50);}}>
                          Purchase Additional Storage<span style={{'display':'block','font-size':'11px','border-top':'1px solid #ffffff'}}>50 additional publications</span>
                      </ProgressButton>
                      <PurchaseMoreStorage authEmail={this.props.authEmail} setLoggedIn={this.props.setLoggedIn} triggerNotification={this.props.triggerNotification} authDetail={this.props.authDetail} show={this.state.showPurchaseMoreStorage} onHide={() => this.hidePurchaseMoreStorage(false)} />
                    </div>
                  :''}
                  {this.props.authDetail.detail.show_cancel_storage?
                    <ProgressButton runningAsyncOperation={this.state.runningCancelExtraStorage} bsStyle="warning pull-right" fill type="submit" onClick={(e) => {this.cancelExtraStorage(e);}}>
                          Cancel My Extra Storage
                      </ProgressButton>
                  :''}</p>
                  No uploaded publications
                  </div>
              }/>}
            </Col>
          </Row>
        </Grid>
        :<div className="spinner-grow text-primary" role="status">
        <span className="sr-only">Loading...</span>
        </div>}
      </div>
    );
  }
}

export default TableList;


const TIMEZONE = {
  ANDORRA: {
      ANDORRA: 'Europe/Andorra'
  },
  AUSTRIA: {
      VIENNA: 'Europe/Vienna'
  },
  BELGIUM: {
      BRUSSELS: 'Europe/Brussels'
  },
  BULGARIA: {
      SOFIA: 'Europe/Sofia'
  },
  CROATIA: {
      ZAGREB: 'Europe/Zagreb'
  },
  CYPRUS: {
      NICOSIA_EUROPE: 'Europe/Nicosia',
      NICOSIA_ASIA: 'Asia/Nicosia',
      FAMAGUSTA: 'Asia/Famagusta'
  },
  CZECHIA: {
      PRAGUE: 'Europe/Prague'
  },
  DENMARK: {
      COPENHAGEN: 'Europe/Copenhagen',
      FAROE: 'Atlantic/Faroe'
  },
  ESTONIA: {
      TALLINN: 'Europe/Tallinn'
  },
  FINLAND: {
      HELSINKI: 'Europe/Helsinki',
      MARIEHAMN: 'Europe/Mariehamn'
  },
  FRANCE: {
      PARIS: 'Europe/Paris',
      CAYENNE: 'America/Cayenne',
      GUADELOUPE: 'America/Guadeloupe',
      MARIGOT: 'America/Marigot',
      MARTINIQUE: 'America/Martinique',
      MAYOTTE: 'Indian/Mayotte',
      REUNION: 'Indian/Reunion'
  },
  GERMANY: {
      BERLIN: 'Europe/Berlin',
      BUSINGEN: 'Europe/Busingen'
  },
  GREECE: {
      ATHENS: 'Europe/Athens'
  },
  HUNGARY: {
      BUDAPEST: 'Europe/Budapest'
  },
  ICELAND: {
      REYKJAVIK: 'Atlantic/Reykjavik'
  },
  IRELAND: {
      DUBLIN: 'Europe/Dublin'
  },
  ITALY: {
      ROME: 'Europe/Rome'
  },
  LATVIA: {
      RIGA: 'Europe/Riga'
  },
  LIECHTENSTEIN: {
      VADUZ: 'Europe/Vaduz'
  },
  LITHUANIA: {
      VILNIUS: 'Europe/Vilnius'
  },
  LUXEMBOURG: {
      LUXEMBOURG: 'Europe/Luxembourg'
  },
  MALTA: {
      MALTA: 'Europe/Malta'
  },
  MONACO: {
      MONACO: 'Europe/Monaco'
  },
  NETHERLANDS: {
      AMSTERDAM: 'Europe/Amsterdam',
      ARUBA: 'America/Aruba',
      CURACAO: 'America/Curacao',
      KRALENDIJK: 'America/Kralendijk',
      LOWER_PRINCES: 'America/Lower_Princes'
  },
  NORWAY: {
      OSLO: 'Europe/Oslo',
      JAN_MAYEN: 'Atlantic/Jan_Mayen',
      LONGYEARBYEN: 'Arctic/Longyearbyen'
  },
  POLAND: {
      WARSAW: 'Europe/Warsaw'
  },
  PORTUGAL: {
      LISBON: 'Europe/Lisbon',
      AZORES: 'Atlantic/Azores',
      MADEIRA: 'Atlantic/Madeira'
  },
  ROMANIA: {
      BUCHAREST: 'Europe/Bucharest'
  },
  SAN_MARINO: {
      SAN_MARINO: 'Europe/San_Marino'
  },
  SLOVAKIA: {
      BRATISLAVA: 'Europe/Bratislava'
  },
  SLOVENIA: {
      LJUBLJANA: 'Europe/Ljubljana'
  },
  SPAIN: {
      MADRID: 'Europe/Madrid',
      CANARY: 'Atlantic/Canary',
      CEUTA: 'Africa/Ceuta'
  },
  SWEDEN: {
      STOCKHOLM: 'Europe/Stockholm'
  },
  SWITZERLAND: {
      ZURICH: 'Europe/Zurich'
  },
  VATICAN: {
      VATICAN: 'Europe/Vatican'
  }
};
const EU_TIMEZONE = [
  TIMEZONE.AUSTRIA.VIENNA,
  TIMEZONE.BELGIUM.BRUSSELS,
  TIMEZONE.BULGARIA.SOFIA,
  TIMEZONE.CROATIA.ZAGREB,
  TIMEZONE.CYPRUS.NICOSIA_EUROPE,
  TIMEZONE.CYPRUS.NICOSIA_ASIA,
  TIMEZONE.CYPRUS.FAMAGUSTA,
  TIMEZONE.CZECHIA.PRAGUE,
  TIMEZONE.DENMARK.COPENHAGEN,
  TIMEZONE.ESTONIA.TALLINN,
  TIMEZONE.FINLAND.HELSINKI,
  TIMEZONE.FINLAND.MARIEHAMN,
  TIMEZONE.FRANCE.PARIS,
  TIMEZONE.GERMANY.BERLIN,
  TIMEZONE.GREECE.ATHENS,
  TIMEZONE.HUNGARY.BUDAPEST,
  TIMEZONE.IRELAND.DUBLIN,
  TIMEZONE.ITALY.ROME,
  TIMEZONE.LATVIA.RIGA,
  TIMEZONE.LITHUANIA.VILNIUS,
  TIMEZONE.LUXEMBOURG.LUXEMBOURG,
  TIMEZONE.MALTA.MALTA,
  TIMEZONE.NETHERLANDS.AMSTERDAM,
  TIMEZONE.POLAND.WARSAW,
  TIMEZONE.PORTUGAL.LISBON,
  TIMEZONE.ROMANIA.BUCHAREST,
  TIMEZONE.SLOVAKIA.BRATISLAVA,
  TIMEZONE.SLOVENIA.LJUBLJANA,
  TIMEZONE.SPAIN.MADRID,
  TIMEZONE.SWEDEN.STOCKHOLM,
  TIMEZONE.FRANCE.CAYENNE,
  TIMEZONE.FRANCE.GUADELOUPE,
  TIMEZONE.FRANCE.MARIGOT,
  TIMEZONE.FRANCE.MARTINIQUE,
  TIMEZONE.FRANCE.MAYOTTE,
  TIMEZONE.FRANCE.REUNION,
  TIMEZONE.PORTUGAL.AZORES,
  TIMEZONE.PORTUGAL.MADEIRA,
  TIMEZONE.SPAIN.CANARY
];
const EEA_EFTA_TIMEZONE = [
  TIMEZONE.ICELAND.REYKJAVIK,
  TIMEZONE.LIECHTENSTEIN.VADUZ,
  TIMEZONE.NORWAY.OSLO,
  TIMEZONE.NORWAY.JAN_MAYEN
];
const EEA_TIMEZONE = [
  ...EU_TIMEZONE,
  ...EEA_EFTA_TIMEZONE
];
const EFTA_TIMEZONE = [
  TIMEZONE.SWITZERLAND.ZURICH,
  ...EEA_EFTA_TIMEZONE
];
const SCHENGEN_TIMEZONE = [
  TIMEZONE.AUSTRIA.VIENNA,
  TIMEZONE.BELGIUM.BRUSSELS,
  TIMEZONE.BULGARIA.SOFIA,
  TIMEZONE.CROATIA.ZAGREB,
  TIMEZONE.CZECHIA.PRAGUE,
  TIMEZONE.DENMARK.COPENHAGEN,
  TIMEZONE.ESTONIA.TALLINN,
  TIMEZONE.FINLAND.HELSINKI,
  TIMEZONE.FINLAND.MARIEHAMN,
  TIMEZONE.FRANCE.PARIS,
  TIMEZONE.GERMANY.BERLIN,
  TIMEZONE.GREECE.ATHENS,
  TIMEZONE.HUNGARY.BUDAPEST,
  TIMEZONE.ITALY.ROME,
  TIMEZONE.LATVIA.RIGA,
  TIMEZONE.LITHUANIA.VILNIUS,
  TIMEZONE.LUXEMBOURG.LUXEMBOURG,
  TIMEZONE.MALTA.MALTA,
  TIMEZONE.NETHERLANDS.AMSTERDAM,
  TIMEZONE.POLAND.WARSAW,
  TIMEZONE.PORTUGAL.LISBON,
  TIMEZONE.PORTUGAL.AZORES,
  TIMEZONE.PORTUGAL.MADEIRA,
  TIMEZONE.ROMANIA.BUCHAREST,
  TIMEZONE.SLOVAKIA.BRATISLAVA,
  TIMEZONE.SLOVENIA.LJUBLJANA,
  TIMEZONE.SPAIN.MADRID,
  TIMEZONE.SPAIN.CANARY,
  TIMEZONE.SWEDEN.STOCKHOLM,
  TIMEZONE.ANDORRA.ANDORRA,
  TIMEZONE.GERMANY.BUSINGEN,
  TIMEZONE.ICELAND.REYKJAVIK,
  TIMEZONE.LIECHTENSTEIN.VADUZ,
  TIMEZONE.MONACO.MONACO,
  TIMEZONE.NORWAY.OSLO,
  TIMEZONE.SAN_MARINO.SAN_MARINO,
  TIMEZONE.SPAIN.CEUTA,
  TIMEZONE.SWITZERLAND.ZURICH,
  TIMEZONE.VATICAN.VATICAN
];
const isTimezoneIn = (tz) => { var _a; return typeof window !== 'undefined' && ((_a = window === null || window === void 0 ? void 0 : window.Intl) === null || _a === void 0 ? void 0 : _a.DateTimeFormat) && tz.includes(Intl.DateTimeFormat().resolvedOptions().timeZone); };
const isFromEU = () => isTimezoneIn(EU_TIMEZONE);
const isFromEEA = () => isTimezoneIn(EEA_TIMEZONE);
const isFromEFTA = () => isTimezoneIn(EFTA_TIMEZONE);
const isFromSchengen = () => isTimezoneIn(SCHENGEN_TIMEZONE);
const euCountries = [
    "Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czech Republic", "Denmark",
    "Estonia", "Finland", "France", "Germany", "Greece", "Hungary", "Ireland", "Italy",
    "Latvia", "Lithuania", "Luxembourg", "Malta", "Netherlands", "Poland", "Portugal",
    "Romania", "Slovakia", "Slovenia", "Spain", "Sweden", "United Kingdom"
];